<template>

    <div class="section-title mb-5">
        Offer wall
    </div>

    <div class="network-list__container">
        <OfferWallTile :network="network" v-for="(network, key) in networks" :key="key" :class="network.name"
            @click="offerWallTileClicked(network)" />
    </div>

    <OfferwallDialog v-if="network" :network="network"></OfferwallDialog>

</template>



<script setup>

import { provide, ref } from 'vue';
import { AppConfigs } from '@/app.configs';
import OfferwallDialog from './Offerwall-Dialog.vue';
import OfferWallTile from '@/components/Tiles/Earn/Offer-Wall-Tile.vue';

const network = ref(null);
const openDialog = ref(false);
provide('openDialog', openDialog);
const networks = Object.entries(AppConfigs.networks).map(([key, value]) => ({ name: key, ...value }));

const offerWallTileClicked = (net) => {
    openDialog.value = true;
    network.value = net;
}

</script>
